"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CharacterPandaOutlineIcon = void 0;
var React = __importStar(require("react"));
function CharacterPandaOutlineIcon(props) {
  var _a, _b, _c, _d;
  return React.createElement("svg", __assign({
    width: (_a = props.width) !== null && _a !== void 0 ? _a : 24,
    height: (_b = props.height) !== null && _b !== void 0 ? _b : 24,
    xmlns: "http://www.w3.org/2000/svg",
    fill: (_c = props.fill) !== null && _c !== void 0 ? _c : "#191C22",
    viewBox: (_d = props.viewBox) !== null && _d !== void 0 ? _d : "0 0 24 24"
  }, props), React.createElement("g", null, React.createElement("path", {
    d: "M7.5 13.5h-3V13a1.5 1.5 0 1 1 3 0v.5ZM19.5 13.5h-3V13a1.5 1.5 0 1 1 3 0v.5ZM10.5 17a1.5 1.5 0 1 0 3 0v-.5h-3v.5Z"
  }), React.createElement("path", {
    d: "M22.963 10.724h-.008c-.27-.79-.64-1.549-1.103-2.262.986-.692 1.647-1.821 1.648-3.112a3.774 3.774 0 0 0-1.19-2.74A4.072 4.072 0 0 0 19.5 1.5c-1.675 0-3.133.994-3.723 2.45A12.89 12.89 0 0 0 12 3.4a12.888 12.888 0 0 0-3.782.551C7.627 2.496 6.174 1.501 4.5 1.5c-1.087 0-2.084.42-2.81 1.11A3.774 3.774 0 0 0 .5 5.35c0 1.29.663 2.418 1.65 3.11C1.084 10.101.5 11.99.5 13.9a7.38 7.38 0 0 0 .956 3.685c.925 1.627 2.439 2.857 4.264 3.675 1.83.82 3.983 1.24 6.28 1.24 3.062-.003 5.873-.744 7.991-2.195 1.057-.726 1.938-1.637 2.553-2.72A7.38 7.38 0 0 0 23.5 13.9a9.809 9.809 0 0 0-.544-3.173l.007-.003Zm-1.486 2.728a1.508 1.508 0 0 1-.14.649c-.13.258-.34.468-.741.65-.398.18-.983.3-1.726.299-.943.002-1.744-.142-2.294-.39-.557-.255-.844-.55-1.007-.968a3.543 3.543 0 0 1-.244-1.28c0-.467.094-.973.257-1.614.076-.314.334-.796.682-1.179.344-.39.774-.675 1.086-.755.29-.08.551-.113.79-.114.675.005 1.214.253 1.725.722.48.445.89 1.104 1.177 1.838.246.699.392 1.419.435 2.142ZM19.5 3.5c.57 0 1.073.218 1.433.56.359.344.566.791.567 1.29 0 .63-.352 1.188-.904 1.53-.071-.074-.134-.153-.208-.225a10.936 10.936 0 0 0-2.758-1.963c.279-.675.996-1.193 1.87-1.192ZM3.057 14.559a1.233 1.233 0 0 1-.4-.458 1.503 1.503 0 0 1-.136-.61 7.858 7.858 0 0 1 .477-2.287c.285-.691.675-1.31 1.131-1.732.511-.469 1.05-.717 1.724-.721.24 0 .501.033.791.113.312.08.742.365 1.086.755.348.383.606.865.682 1.18.163.64.257 1.146.257 1.613a3.546 3.546 0 0 1-.244 1.28c-.163.419-.45.713-1.007.969-.55.247-1.351.39-2.294.389-.994.003-1.693-.216-2.067-.491ZM2.5 5.35c0-.499.208-.946.567-1.29.36-.342.863-.56 1.433-.56.874-.001 1.59.518 1.867 1.193a10.938 10.938 0 0 0-2.755 1.962c-.073.072-.136.15-.206.224-.553-.342-.907-.9-.906-1.529Zm14.961 14.085c-1.522.684-3.41 1.066-5.461 1.065-2.737.003-5.175-.681-6.858-1.843a6.403 6.403 0 0 1-1.791-1.821 7.054 7.054 0 0 0 1.773.214c1.133-.002 2.188-.157 3.105-.561.912-.396 1.705-1.106 2.07-2.098a5.563 5.563 0 0 0 .37-1.98c0-.734-.143-1.41-.319-2.105-.19-.731-.595-1.418-1.13-2.021-.54-.596-1.212-1.113-2.045-1.35a5.232 5.232 0 0 0-.527-.109C8.094 5.95 9.881 5.402 12 5.4c2.119.002 3.905.548 5.35 1.425a5.22 5.22 0 0 0-.531.11c-.833.237-1.505.754-2.044 1.35-.535.603-.94 1.29-1.13 2.02-.177.696-.32 1.372-.32 2.107a5.561 5.561 0 0 0 .37 1.98c.365.991 1.158 1.7 2.07 2.097.917.404 1.972.559 3.105.56a7.179 7.179 0 0 0 1.76-.202c-.684 1.063-1.755 1.954-3.169 2.588Z"
  })));
}
exports.CharacterPandaOutlineIcon = CharacterPandaOutlineIcon;